import { IIconProps } from '#components/icons/types';

const CalendarAddOn = ({ size = 48, color }: IIconProps) => {
  return (
    <svg viewBox="0 0 24 24" width={size} height={size} fill={color}>
      <path d="M17.25 21.75v-3h-3v-1.5h3v-3h1.5v3h3v1.5h-3v3ZM5.3 19.5q-.75 0-1.275-.525Q3.5 18.45 3.5 17.7V6.3q0-.75.525-1.275Q4.55 4.5 5.3 4.5h1.4V2.375h1.525V4.5H13.8V2.375h1.5V4.5h1.4q.75 0 1.275.525.525.525.525 1.275v5.925q-.375-.05-.75-.05t-.75.05V10.3H5v7.4q0 .1.1.2t.2.1h6.85q0 .375.038.75.037.375.162.75Z" />
    </svg>
  );
};

export default CalendarAddOn;
